import { render, staticRenderFns } from "./positioncontrast.vue?vue&type=template&id=57637e02&scoped=true"
import script from "./positioncontrast.vue?vue&type=script&lang=js"
export * from "./positioncontrast.vue?vue&type=script&lang=js"
import style0 from "./positioncontrast.vue?vue&type=style&index=0&id=57637e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57637e02",
  null
  
)

export default component.exports